import type {
  UseGetVendorMaterialPricingPlanParams,
  UseGetVendorMaterialPricingPlanQueryKey,
} from './types';

export const getUseGetVendorsMaterialPricingPlanQueryKey = (
  params: UseGetVendorMaterialPricingPlanParams,
): UseGetVendorMaterialPricingPlanQueryKey => [
  'vendors',
  'vendorsMaterialPricingPlan',
  params,
];
